import React from "react";
import { useTranslation } from "react-i18next";
import OInputField from "../../components/reusable/OInputField";
import OSelect from "../../components/reusable/OSelect";

const PositionStep = ({ register, errors, permission, user }) => {
  const { t } = useTranslation();

  const employmentTypeOptions = [
    { value: "full-time", key: t("full-time") || "full-time" },
    { value: "part-time", key: t("part-time") || "part-time" },
    { value: "contract", key: t("contract") || "contract" },
    { value: "internship", key: t("internship") || "internship" },
    { value: "remote", key: t("remote") || "remote" },
  ];

  const employmentTypeArOptions = [
    { value: "دوام كامل", key: "دوام كامل" },
    { value: "دوام جزئي", key: "دوام جزئي" },
    { value: "عقد", key: "عقد" },
    { value: "تدريب", key: "تدريب" },
    { value: "عن بُعد", key: "عن بُعد" },
  ];

  const experienceLevelOptions = [
    { value: "entry", key: t("entry") || "entry" },
    { value: "mid", key: t("mid") || "mid" },
    { value: "senior", key: t("senior") || "senior" },
    { value: "executive", key: t("executive") || "executive" },
  ];

  const experienceLevelArOptions = [
    { value: "مبتدئ", key: "مبتدئ" },
    { value: "متوسط", key: "متوسط" },
    { value: "مستوى عالي", key: "مستوى عالي" },
    { value: "تنفيذي", key: "تنفيذي" },
  ];

  const statusOptions = [
    { value: "active", key: t("active") || "active" },
    { value: "inactive", key: t("inactive") || "inactive" },
    { value: "closed", key: t("closed") || "closed" },
  ];

  const minDate = new Date();
  const y = minDate.getFullYear();
  const m = String(minDate.getMonth() + 1).padStart(2, "0");
  const d = String(minDate.getDate()).padStart(2, "0");
  const minDateStr = `${y}-${m}-${d}`;

  return (
    <div className="grid md:grid-cols-2 gap-6">
      <OInputField
        inputLabel={t("O_LOCATION")}
        name="location"
        type="text"
        disabled={!(permission?.add || user.role === "admin")}
        placeholder={
          t("Enter location") || "Enter location e.g., Abu Dhabi, UAE"
        }
        register={register("location", {
          required: t("Location is required") || "Location is required",
        })}
        errors={errors}
        requiredMark
      />
      <OInputField
        inputLabel="Location (Ar)"
        name="locationAr"
        disabled={!(permission?.add || user.role === "admin")}
        type="text"
        placeholder={t("Enter Arabic location") || "Enter Arabic location"}
        register={register("locationAr")}
        errors={errors}
      />
      <OInputField
        inputLabel={t("CAREERS_DEPARTMENT")}
        disabled={!(permission?.add || user.role === "admin")}
        name="department"
        type="text"
        placeholder={
          t("Enter department") || "Enter department e.g., Marketing"
        }
        register={register("department", {
          required: t("Department is required") || "Department is required",
        })}
        errors={errors}
        requiredMark
      />
      <OInputField
        inputLabel="Department (Ar)"
        name="departmentAr"
        disabled={!(permission?.add || user.role === "admin")}
        type="text"
        placeholder={t("Enter Arabic department") || "Enter Arabic department"}
        register={register("departmentAr")}
        errors={errors}
      />

      <OSelect
        inputLabel={t("CAREERS_EMPLOYMENT_TYPE")}
        name="employmentType"
        register={register("employmentType", {
          required:
            t("Employment type is required") || "Employment type is required",
        })}
        disabled={!(permission?.add || user.role === "admin")}
        errors={errors}
        requiredMark
        options={employmentTypeOptions}
        placeholder={t("Select employment type") || "Select employment type"}
      />
      <OSelect
        inputLabel={t("Employment Type (Ar)")}
        name="employmentTypeAr"
        register={register("employmentTypeAr")}
        disabled={!(permission?.add || user.role === "admin")}
        errors={errors}
        options={employmentTypeArOptions}
        placeholder={
          t("Select Arabic employment type") || "Select Arabic employment type"
        }
      />

      <OSelect
        inputLabel={t("Experience Level")}
        name="experienceLevel"
        register={register("experienceLevel", {
          required:
            t("Experience level is required") || "Experience level is required",
        })}
        errors={errors}
        disabled={!(permission?.add || user.role === "admin")}
        requiredMark
        options={experienceLevelOptions}
        placeholder={t("Select experience level") || "Select experience level"}
      />
      <OSelect
        inputLabel={t("Experience Level (Ar)")}
        name="experienceLevelAr"
        register={register("experienceLevelAr")}
        disabled={!(permission?.add || user.role === "admin")}
        errors={errors}
        options={experienceLevelArOptions}
        placeholder={
          t("Select Arabic experience level") ||
          "Select Arabic experience level"
        }
      />

      <OInputField
        inputLabel="Application Deadline"
        disabled={!(permission?.add || user.role === "admin")}
        name="applicationDeadline"
        type="date"
        register={register("applicationDeadline", {
          required:
            t("Application deadline is required") ||
            "Application deadline is required",
        })}
        errors={errors}
        requiredMark
        min={minDateStr}
      />

      <OSelect
        inputLabel="Status"
        disabled={!(permission?.add || user.role === "admin")}
        name="status"
        register={register("status")}
        errors={errors}
        options={statusOptions}
        placeholder={t("Select status") || "Select status"}
      />
    </div>
  );
};

PositionStep.fields = [
  "location",
  "department",
  "employmentType",
  "experienceLevel",
  "applicationDeadline",
];

export default PositionStep;
